<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'DetailDrawer',
})
</script>
<template>
  <Drawer v-model:visible="visible" title="文件详情" width="500px" destroyOnClose class="ant-cus-drawer">
    <Descriptions layout="vertical" :column="1" size="middle">
      <Descriptions.Item label="文件ID">{{ record?.id }}</Descriptions.Item>
      <Descriptions.Item label="文件名">{{ record?.fileName }}</Descriptions.Item>
      <Descriptions.Item label="文件展示名">{{ record?.fileShowName }}</Descriptions.Item>
      <Descriptions.Item label="文件编号">{{ record?.fileCodeNumber }}</Descriptions.Item>
      <Descriptions.Item label="文件MD5">{{ record?.fileMd5 }}</Descriptions.Item>
      <Descriptions.Item label="文件大小">{{ record?.fileSize ? friendBytes(record.fileSize) : '' }}</Descriptions.Item>
      <Descriptions.Item label="文件时间">{{ record?.fileShowTime }}</Descriptions.Item>
      <Descriptions.Item label="备注">{{ record?.mark }}</Descriptions.Item>
      <Descriptions.Item label="上传时间">{{ record?.createdAt }}</Descriptions.Item>
      <Descriptions.Item label="更新时间">{{ record?.updatedAt }}</Descriptions.Item>
    </Descriptions>
    <template #footer>
      <BdBtn :icon="DownloadOutlined" type="primary" @click="download">下载</BdBtn>
    </template>
  </Drawer>
</template>

<script lang="ts" setup name="DetailDrawer">
import { Descriptions, Drawer } from 'ant-design-vue'
import { ref, shallowRef } from 'vue'
import { friendBytes } from '@bd/vue3-utils'
import { DownloadOutlined } from '@ant-design/icons-vue'
import { BdBtn } from '-/Common/BdBtn'
import { useFileDownload } from './useFile'

const visible = ref(false)
const record = shallowRef<Partial<ApiFile.Item>>({})

const { download } = useFileDownload(record)
const open = (data: Partial<ApiFile.Item>) => {
  record.value = data
  visible.value = true
}
defineExpose({ open })
</script>
